import $ from "jquery";

$('#loginForm').on('submit', function (e) {
    e.preventDefault();
    $(this).find('button').prop('disabled', true);
    e.currentTarget.submit();
});